import { NavbarComponent } from './../../components/navbar/navbar.component';
import { Subject, fromEvent } from 'rxjs';
import { takeUntil, auditTime } from 'rxjs/operators';
import { Component, OnInit, OnDestroy, AfterViewInit, ViewChild, Renderer2, ElementRef, Input, ChangeDetectorRef } from '@angular/core';
import { ActivatedRoute, NavigationEnd, Router, NavigationStart } from '@angular/router';
import { ScApiService } from '@sc-ui';
import { PLATFORM_ID, Inject } from '@angular/core';
import { isPlatformBrowser, isPlatformServer } from '@angular/common';
import { ScrollspyService } from 'src/services/scrollspy.service';
import { ChatsService, ScChatbotOverlayComponent } from '@sc-ui-chatbot';
import { GoogleAnalyticsService } from '@sc-ui';
import { LocalizationService } from 'src/services/localization.service';
import { Meta } from '@angular/platform-browser';


@Component({
  selector: 'app-job',
  templateUrl: './job.component.html',
  styleUrls: ['./job.component.scss']
})
export class JobComponent implements OnInit, OnDestroy, AfterViewInit {

  TravelIntensity = {
    0: 'Keine Reisetätigkeit',
    1: 'Geringfügige Reisetätigkeit',
    2: 'Mittlere Reisetätigkeit',
    3: 'Hohe Reisetätigkeit'
  }

  $destroy = new Subject();

  job: any;

  language = 'de';

  @Input()
  secret: string;

  chat: any = null;

  initialChat: any = null;

  @ViewChild(ScChatbotOverlayComponent) chatOverlay: ScChatbotOverlayComponent;

  isMobileBreakpoint: boolean = false;

  isBrowser: boolean;

  isSkillconomy() { return this.job?.Company?.Id == 1 };

  constructor(
    private renderer2: Renderer2,
    private api: ScApiService,
    private chatService: ChatsService,
    private route: ActivatedRoute,
    private router: Router,
    private meta: Meta,
    @Inject(PLATFORM_ID) private platformId: string,
    private scrollSpy: ScrollspyService,
    private ga: GoogleAnalyticsService,
    private localization: LocalizationService) {

    this.isBrowser = isPlatformBrowser(platformId);

  }

  ngOnInit() {

    if (this.secret) {
      this.init();
    }

    this.route.params.subscribe((params: any) => {
      if (!params.secret) return;
      this.secret = params.secret;
      this.init();
    });


    if (typeof window !== 'undefined') {
      fromEvent(window, 'resize')
        .pipe(auditTime(250))
        .subscribe(() => this.checkBreakpoint());
    }

  }

  scrollToSection(anchorId) {

    const targetElement = document.querySelector('section#' + anchorId);
    
    if (targetElement) {
      targetElement.scrollIntoView({
        behavior: 'smooth',
        block: 'start'
      });
    }
  }

  init() {
    if (!this.secret) return;


    this.api.get('jobs/' + this.secret).subscribe((d: any) => {

      this.localization.setCulture(d.Locale);

      this.job = this.preprocessData(d);
      this.language = this.job.Language;

      var now = new Date();

      var title = this.job.Name + ' (m/w/d)';
      var description = "Die Highlights: ";

      for (var i = 0; i < this.job.Highlights?.length; i++) {
        var highlight = this.job.Highlights[i];
        var isLast = i == this.job.Highlights.length - 1;
        description += highlight;
        if (!isLast) description += ", ";
      }

      this.meta.addTag({ name: "title", content: title });
      this.meta.addTag({ name: "datePosted", content: now.toISOString() });
      this.meta.addTag({ name: "description", content: description });

      this.meta.addTag({ name: "og:type", content: "article" });
      this.meta.addTag({ name: "og:title", content: title });
      this.meta.addTag({ name: "og:description", content: description });
      this.meta.addTag({ name: "og:url", content: 'https://jobs.skillconomy.com/job/' + this.secret });
      this.meta.addTag({ name: "og:image", content: this.job.SharingImageUri });

      this.meta.addTag({ name: "twitter:title", content: title });
      this.meta.addTag({ name: "twitter:description", content: description });
      this.meta.addTag({ name: "twitter:image", content: this.job.SharingImageUri });


      this.trace();
      // this.trackFacebookPixel();
      // this.sendGoogleAnalyticsEvent();
      this.initChatbot();


    }, err => {
      this.router.navigate(['/404']);
    });

  }

  trace() {
    this.api.post(`jobs/${this.secret}/trace`, null).subscribe();
  }

  initChatbot() {
    if (!this.secret) return;
    this.chatService.getChat('jobs/' + this.secret + '/chats').subscribe((c: any) => {
      this.chat = c;
      this.initialChat = c;
      if (this.chatOverlay?.trigger) {
        this.chatOverlay.trigger.slideIn();
        this.chatOverlay.trigger.badge = 1;
      }
    });
  }

  optOutClick() {
    if (!this.secret) return;
    this.chatService.getChat('jobs/' + this.secret + '/chats/opt-out').subscribe((c: any) => {
      this.chat = c;
      if (this.chatOverlay?.trigger) {
        this.chatOverlay.trigger.slideIn();
      }
      this.chatOverlay.show();
    });
  }

  showInitialChatbot() {
    this.chat = this.initialChat;
    this.chatOverlay.show();
  }

  handleEndOfChat(chat) {
    if (chat != this.initialChat) {
      this.chatOverlay.hide();
      setTimeout(() => {
        this.chat = this.initialChat;
      }, 300);

    }
  }

  private sendGoogleAnalyticsEvent() {
    if (this.job.Candidate && this.job.Candidate.Guid) {
      this.ga.track('jobsitevisit');
      this.ga.track('jobsitevisit_' + this.job.Id);
    };
  }



  preprocessData(data: any) {
    data.TravelIntensity = this.TravelIntensity[data.TravelIntensity];
    return data;
  }

  checkBreakpoint() {
    if (this.isBrowser) {
      if (window.innerWidth <= 767.98) {
        this.renderer2.addClass(document.body, 'breakpoint-sm');
        this.isMobileBreakpoint = true;
      } else {
        this.renderer2.removeClass(document.body, 'breakpoint-sm');
        this.isMobileBreakpoint = false;
      }
    }
  }

  ngAfterViewInit() {
    this.checkBreakpoint();
    this.initScrollSpy();
  }

  public initScrollSpy() {

    if (isPlatformServer(this.platformId)) return;

    setTimeout(() => {
      var menuElements = [].slice.call(document.querySelectorAll('section'));

      this.scrollSpy.spyNativeElements(menuElements).subscribe((activeIndex: any) => {
        var element = menuElements[activeIndex];
        menuElements.filter(e => e != element).forEach(e => {
          e.classList.remove('inview');
        });
        element.classList.add('inview');

      });
    }, 500);
  }

  ngOnDestroy() {
    this.$destroy.next();
  }

}
